import { render, staticRenderFns } from "./Filing.vue?vue&type=template&id=5b45dae9&"
import script from "./Filing.vue?vue&type=script&lang=js&"
export * from "./Filing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports